import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TagService {
  private http: HttpClient = inject(HttpClient);

  getAll(): Observable<string[]> {
    return this.http.get<{ tags: string[] }>(`${environment.apiBaseUrl}/tags`).pipe(
      map((response) => {
        return response.tags || [];
      })
    );
  }
}
